import CryptoJS from 'crypto-js';

import config from "../../../config/domain";
export const decryptJwtToken = (encryptedToken: any) => {
    const publicKey = config?.publicKey; // Use the same public key used in C#
    const secretKey = config?.secretKey; // Use the same secret key from _appSettings.Secret in C#


    const key = CryptoJS.enc.Utf8.parse(secretKey);
    const iv = CryptoJS.enc.Utf8.parse(publicKey);
    let decryptedNew = CryptoJS.DES.decrypt(
        decodeURIComponent(decodeURIComponent(encryptedToken)),
        key,
        {
            keySize: 32,
            iv: iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7,
        }
    );
    return decryptedNew.toString(CryptoJS.enc.Utf8);

};



